import agentFr from '@a6tr/i18n/translations/fr.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import backofficeFr from './fr.json';

// Sign-in and shared component labels come from the agent front's translations, so the screens
// both apps share read the same. The back-office's own file overrides what differs.
const fr = {
	...backofficeFr,
	auth: {
		...agentFr.auth,
		...backofficeFr.auth,
		login: {
			...agentFr.auth.login,
			...backofficeFr.auth.login,
			errors: {
				...agentFr.auth.login.errors,
				...backofficeFr.auth.login.errors,
			},
		},
	},
	common: { ...agentFr.common, ...backofficeFr.common },
};

export type GlobalTranslations = typeof fr;

export const defaultNS = 'global' as const;

// The back-office is used by The Treep staff only, in French.
void i18n.use(initReactI18next).init({
	resources: { fr: { [defaultNS]: fr } },
	lng: 'fr',
	fallbackLng: 'fr',
	defaultNS,
	interpolation: { escapeValue: false },
});

export default i18n;
